
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.2 6.933c1.244 2.49 3.378 4.534 5.867 5.867l1.955-1.956c.267-.266.622-.355.89-.177.977.355 2.044.533 3.2.533.532 0 .888.356.888.889v3.022c0 .533-.356.889-.889.889C6.756 16 0 9.244 0 .889A.89.89 0 01.889 0H4c.533 0 .889.356.889.889 0 1.067.178 2.133.533 3.2.09.267 0 .622-.178.889L3.2 6.933zM9.778 0c-.534 0-.89.356-.89.889s.356.889.89.889c.533 0 .889-.356.889-.89 0-.532-.356-.888-.89-.888zm2.666 0c-.533 0-.888.356-.888.889s.355.889.888.889c.534 0 .89-.356.89-.89 0-.532-.356-.888-.89-.888zm2.667 0c-.533 0-.889.356-.889.889s.356.889.89.889c.532 0 .888-.356.888-.89C16 .357 15.644 0 15.111 0zM9.778 2.667c-.534 0-.89.355-.89.889 0 .533.356.888.89.888.533 0 .889-.355.889-.888 0-.534-.356-.89-.89-.89zm2.666 0c-.533 0-.888.355-.888.889 0 .533.355.888.888.888.534 0 .89-.355.89-.888 0-.534-.356-.89-.89-.89zm2.667 0c-.533 0-.889.355-.889.889 0 .533.356.888.89.888.532 0 .888-.355.888-.888 0-.534-.356-.89-.889-.89zM9.778 5.333c-.534 0-.89.356-.89.89 0 .533.356.888.89.888.533 0 .889-.355.889-.889 0-.533-.356-.889-.89-.889zm2.666 0c-.533 0-.888.356-.888.89 0 .533.355.888.888.888.534 0 .89-.355.89-.889 0-.533-.356-.889-.89-.889zm2.667 0c-.533 0-.889.356-.889.89 0 .533.356.888.89.888.532 0 .888-.355.888-.889 0-.533-.356-.889-.889-.889z","fill":"#00A807"}})])
          )
        }
      }
    